// const uaAddCart = ( products:products[] ) =>{
//     window.dataLayer.push({
//         'event': 'addToCart',
//         'ecommerce': {
//             'currencyCode': 'KRW',
//             'add': {
//                 'products': products
//             }
//         }
//     });
// }
var ga4AddCart = function (items) {
    window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            items: items
        }
    });
    console.log(window.dataLayer);
};
export var gaAddCartItemProcess = function (item, cartData, stdpcOption) {
    var products_cateName = item.category.map(function (v) {
        return v.cate_name;
    });
    var products = [{
            name: item.item_name,
            id: item.item_id,
            price: item.price_low,
            brand: item.maker_name,
            category: products_cateName.join(' / '),
            variant: '',
            quantity: cartData.count,
            coupon: ''
        }];
    var items = [{
            item_name: item.item_name,
            item_id: item.item_id,
            price: item.price_low,
            item_brand: item.maker_name,
            item_category: (products_cateName[0]) ? products_cateName[0] : '',
            item_category2: (products_cateName[1]) ? products_cateName[1] : '',
            item_category3: (products_cateName[2]) ? products_cateName[2] : '',
            item_category4: (products_cateName[3]) ? products_cateName[3] : '',
            item_category5: (products_cateName[4]) ? products_cateName[4] : '',
            item_variant: '',
            coupon: '',
            quantity: cartData.count,
        }];
    if (stdpcOption) {
        var stdpcItemArray_1 = [];
        var stdpcTypeArray_1 = [];
        var stdpcChangeArray_1 = [];
        var stdpcChangeItemArray_1 = [];
        stdpcOption.baseList.map(function (v) {
            v.child[0].chile.map(function (vv) {
                stdpcItemArray_1.push(vv);
            });
        });
        if (cartData.stdpcType) {
            cartData.stdpcType.map(function (v) {
                stdpcTypeArray_1.push(v);
            });
        }
        if (cartData.stdpcType2) {
            cartData.stdpcType2.map(function (v) {
                stdpcTypeArray_1.push(v);
            });
        }
        stdpcTypeArray_1.map(function (v) {
            stdpcItemArray_1.map(function (vv) {
                if (v === vv.idx_match_stdpc_item && vv.real_item_id) {
                    var stdpc_cateName = vv.category.map(function (vvv) {
                        return vvv.cate_name;
                    });
                    var stdpcObject = {
                        name: vv.item_name,
                        id: vv.real_item_id,
                        price: 0,
                        brand: vv.maker_name,
                        category: stdpc_cateName.join(' / '),
                        variant: '조립PC',
                        quantity: cartData.count * vv.cnt_pack,
                        coupon: ''
                    };
                    var stdpcItems = {
                        item_name: vv.item_name,
                        item_id: vv.real_item_id,
                        price: 0,
                        item_brand: vv.maker_name,
                        item_category: (stdpc_cateName[0]) ? stdpc_cateName[0] : '',
                        item_category2: (stdpc_cateName[1]) ? stdpc_cateName[1] : '',
                        item_category3: (stdpc_cateName[2]) ? stdpc_cateName[2] : '',
                        item_category4: (stdpc_cateName[3]) ? stdpc_cateName[3] : '',
                        item_category5: (stdpc_cateName[4]) ? stdpc_cateName[4] : '',
                        item_variant: '조립PC',
                        coupon: '',
                        quantity: cartData.count * vv.cnt_pack,
                    };
                    products.push(stdpcObject);
                    items.push(stdpcItems);
                }
            });
        });
        if (cartData.stdpcType3) {
            cartData.stdpcType3.map(function (v) {
                stdpcChangeArray_1.push(v);
            });
        }
        if (cartData.stdpcType4) {
            cartData.stdpcType4.map(function (v) {
                stdpcChangeArray_1.push(v);
            });
        }
        if (stdpcChangeArray_1 && stdpcChangeArray_1.length > 0) {
            stdpcOption.addList.map(function (v) {
                v.child[0].chile.map(function (vv) {
                    stdpcChangeItemArray_1.push(vv);
                });
            });
            stdpcChangeArray_1.map(function (v) {
                stdpcChangeItemArray_1.map(function (vv) {
                    if (v === vv.idx_match_stdpc_item && vv.real_item_id) {
                        var stdpc_cateName = vv.category.map(function (vvv) {
                            return vvv.cate_name;
                        });
                        var stdpcObject = {
                            name: vv.item_name,
                            id: vv.real_item_id,
                            price: 0,
                            brand: vv.maker_name,
                            category: stdpc_cateName.join(' / '),
                            variant: '조립PC',
                            quantity: cartData.count * vv.cnt_pack,
                            coupon: ''
                        };
                        var stdpcItems = {
                            item_name: vv.item_name,
                            item_id: vv.real_item_id,
                            price: 0,
                            item_brand: vv.maker_name,
                            item_category: (stdpc_cateName[0]) ? stdpc_cateName[0] : '',
                            item_category2: (stdpc_cateName[1]) ? stdpc_cateName[1] : '',
                            item_category3: (stdpc_cateName[2]) ? stdpc_cateName[2] : '',
                            item_category4: (stdpc_cateName[3]) ? stdpc_cateName[3] : '',
                            item_category5: (stdpc_cateName[4]) ? stdpc_cateName[4] : '',
                            item_variant: '조립PC',
                            coupon: '',
                            quantity: cartData.count * vv.cnt_pack,
                        };
                        products.push(stdpcObject);
                        items.push(stdpcItems);
                    }
                });
            });
        }
    }
    // uaAddCart(products)
    ga4AddCart(items);
};
export var gaViewItemProcess = function (item) {
    var products_cateName = item.category.map(function (v) {
        return v.cate_name;
    });
    var products = [{
            name: item.item_name,
            id: item.item_id,
            price: item.price_low,
            brand: item.maker_name,
            category: products_cateName.join(' / '),
            variant: ''
        }];
    var items = [{
            item_name: item.item_name,
            item_id: item.item_id,
            price: item.price_low,
            item_brand: item.maker_name,
            item_category: (products_cateName[0]) ? products_cateName[0] : '',
            item_category2: (products_cateName[1]) ? products_cateName[1] : '',
            item_category3: (products_cateName[2]) ? products_cateName[2] : '',
            item_category4: (products_cateName[3]) ? products_cateName[3] : '',
            item_category5: (products_cateName[4]) ? products_cateName[4] : '',
            item_variant: '',
            quantity: 1,
        }];
    // uaViewItem(products)
    ga4ViewItem(items);
};
// const uaViewItem = ( products:uaDetailProducts[] ) =>{
//     window.dataLayer.push({
//         'event': "ProductImpression",
//         'ecommerce': {
//             'detail': {
//                 'actionField': {'list': ''},
//                 'products': products
//             }
//         }
//     });
// }
var ga4ViewItem = function (items) {
    window.dataLayer.push({
        event: "view_item",
        ecommerce: {
            items: items
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/libs/googleTagmanager.tsx
// module id = 60
// module chunks = 0